import { p } from "./createTheme-02ce03eb.js";
const e = p.oneOfType([p.func, p.object]), r = e;
export {
  r
};
